import { useTranslations } from 'next-intl';

import { Link } from '@/components/Link';

import clsx from 'clsx';

type Props = {
  className?: string;
};

export function TermsConditionsAndPrivacyPolicyLink({ className }: Props) {
  const t = useTranslations('general');

  return (
    <p
      className={clsx(className ?? 'text-sm')}
      data-testid="terms-privacy-policy-description"
    >
      {t.rich('terms-conditions-privacy-policy', {
        termsLink: (chunks) => (
          <Link
            className="underline"
            href="/site-portal-terms"
            rel="noopener"
            target="_blank"
          >
            {chunks}
          </Link>
        ),
        pricacyPolicyLink: (chunks) => (
          <Link
            className="underline"
            href="/privacy-policy"
            rel="noopener"
            target="_blank"
          >
            {chunks}
          </Link>
        ),
      })}
    </p>
  );
}
